<template>
  <CRow v-if="oilColor">
    <CCol>
      <CCard>
        <CCardBody class="pb-0 d-flex justify-content-between">
          <div>
            <div class="text-value-lg">
              <BBadge :style="{backgroundColor: oilColor, color: 'black'}">{{oilName}}</BBadge>
              {{ trans(store.ovm,'v',volUnit) }}
              <BBadge>{{ unitSign(volUnit)}}</BBadge>
              <BBadge :variant="percentVariant(store.pct)" class="ml-2 mr-1">{{ store.pct }} %</BBadge>
            </div>

          </div>
        </CCardBody>
        <slot name="footer">
          <CChartLine
            class="mt-2"
            :datasets="oilDataSet"
            :options="graphOptions"
            :labels="labels"
          />

<!--          <CChartLineSimple
            class="mt-3"
            style="max-height:200px"
            :background-color="oilColor"
            :data-points="oilData"
            :options="{ elements: { line: { borderWidth: 2.5 }}}"
            :point-hover-background-color="oilColor"
            :label="oilName"
            :labels="labels"
            :tickMax="store.max"
            :pointed="false"
          />-->
        </slot>
      </CCard>


      <!--
      <CWidgetDropdown
        :header="`${store.ovm}`"
        :text="`${oilName} 충족률 ${store.pct} %`"
      >
        <template #default>
          <CDropdown
            color="transparent p-0"
            placement="bottom-end"
          >
            <template #toggler-content>
              <CIcon name="cil-settings"/>
            </template>
            <CDropdownItem>Liter</CDropdownItem>
            <CDropdownItem>Drum</CDropdownItem>
            <CDropdownItem>Gallon</CDropdownItem>
          </CDropdown>
        </template>
        <template #footer>
          <CChartLineSimple
            class="mt-3"
            style="height:70px"
            :background-color="oilColor"
            :data-points="oilData"
            :options="{ elements: { line: { borderWidth: 2.5 }}}"
            :point-hover-background-color="oilColor"
            :label="oilName"
            :labels="labels"
          />
        </template>
      </CWidgetDropdown>
      -->
    </CCol>

  </CRow>
</template>

<script>
// import { CChartLineSimple } from '../charts'
import { CChartLine } from '@coreui/vue-chartjs'
import { trans, unitSign } from '@/common/utils'

export default {
  name: 'WidgetsOils',
  components: { CChartLine },
  props:{
    oilCode: { type: String, default: ''},
    oilName: { type: String, default: ''},
    oilColor: { type: String, default: '#FFFFFF'},
    store: { type: Object, default: null },
    oilData: { type: Array, default: null },
    labels: { type: Array, default: null },
    volUnit: { type: String, default: 'k' }, // 부모(유종별현황 카드)에서 선택한 단위

  },
  data () {
    return {
      trans: trans,
      unitSign: unitSign,
    }
  },
  computed: {
    // Y축 스케일: 총용량 이상을 5등분하되 눈금이 깔끔한 단위(1,2,2.5,5)가 되도록 계산
    yScale(){
      const max = Number(this.store?.max) || 0;
      if( max <= 0 ) return {};
      const raw = max / 5;
      const p = Math.pow(10, Math.floor(Math.log10(raw)));
      const mult = [1, 2, 2.5, 5, 10].find( m => m * p >= raw );
      const step = mult * p;
      return { max: step * 5, stepSize: step };
    },

    // 기간/단위 콤보 변경 시 재계산되도록 computed 로 구성한다
    oilDataSet(){
      const ds = [
        {
          data: this.oilData,
          borderColor: '#ffffff',
          backgroundColor: this.oilColor,
          pointBackgroundColor: this.oilColor,
          pointHoverBackgroundColor: this.oilColor,
          label: this.oilName
        }
      ];

      // 유종별 안전재고 합계 점선 (붉은색, 리터 기준. 설정된 유종만 표시)
      const safetyVol = Number(this.store?.safetyVolume) || 0;
      if( safetyVol > 0 && this.oilData?.length ){
        ds.push({
          data: new Array(this.oilData.length).fill(safetyVol),
          borderColor: '#f86c6b',
          backgroundColor: 'transparent',
          borderDash: [6, 4],
          pointRadius: 0,
          label: '안전재고'
        })
      }
      return ds;
    },

    graphOptions(){
      // 콜백 안에서만 참조하면 반응성 의존으로 잡히지 않으므로 여기서 미리 읽는다
      const unit = this.volUnit;
      return {
        scales: {
          xAxes: [{
            display: true,
            gridLines: { display: false },
            ticks: {
              autoSkip: true,
              maxTicksLimit: 10,
              maxRotation: 0,
              fontSize: 10
            }
          }],
          yAxes: [{
            display: true,
            gridLines: { color: 'rgba(255,255,255,0.1)' },
            ticks: {
              ...this.yScale,
              beginAtZero: true,
              fontSize: 10,
              // 원본 데이터는 리터이므로 선택 단위로 환산해 표시한다
              callback: v => trans(v, 'v', unit)
            }
          }]
        },
        elements: {
          line: {
            borderWidth: 2
          },
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4
          }
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        }
      }
    }
  },
 methods: {
   percentVariant(pct){
     if(pct < 10) return 'warning';
     if(pct > 90) return 'danger';
     return 'info';
   }
 }
}
</script>
